import React from 'react';
import './PhoneLink.less';

export const PhoneLink = ({phone, children}) => {
	const plusSymbol = phone.length == 8 || phone.length == 9 ? '' : '+'; //SNAP-4870 Do not add + in front of norwegian number

	return <a href={`tel:${plusSymbol}${phone.replace('+', '').replace(/\s/g, '')}`} target="_blank">{children}</a>
}
